import { sessionService } from '@/providers/services/auth/session';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Impact extends Vue {

  get session() {
    return sessionService.getSession();
  }
  private impactHeader: any = [
    {
      label: 'Dashboard',
      key: 'dashboard',
      symbol: 'format_align_center',
      isActive: true,
    },
    {
      label: 'Performance',
      key: 'performance',
      icon: 'settings',
      symbol: 'speed',
      isActive: false,
    },
    {
      label: 'NCPAT Math Progress',
      key: 'parcc',
      icon: 'settings',
      symbol: 'arrow_upward',
      isActive: false,
    },
    {
      label: 'Overall Progress',
      key: 'growth',
      icon: 'settings',
      symbol: 'arrow_upward',
      isActive: false,
    },
    {
      label: 'Attendance',
      key: 'attendance',
      icon: 'settings',
      symbol: 'task_alt',
      isActive: false,
    },
  ];

  public updated() {
    const value = this.$route.query.name;
    if (value) {
    this.impactHeader.map((item: any) => {
      if (item.key === value) {
        item.isActive = true;
      } else {
        item.isActive = false;
      }
    });
  }
}
  // ---ACTION---
  private onAction(option: any) {
    this.impactHeader.map((item: { isActive: boolean }) => {
      item.isActive = false;
    });
    option.isActive = true;
    if (option.key === 'dashboard') {
      this.$router.push('/impact-dashboard');
    }
    if (option.key === 'performance') {
      this.$router.push('/impact-performance');
    }
    if (option.key === 'parcc') {
      this.$router.push('/impact-growth');
    }
    if (option.key === 'growth') {
      this.$router.push('/impact-ela-growth');
    }
    if (option.key === 'attendance') {
      this.$router.push('/impact-attendance');
    }
  }
}
